import loadParallax from "../services/parallax";
var NewsSearch = /** @class */ (function () {
    /**
     *
     */
    function NewsSearch(el) {
        var _this = this;
        this.categoryEl = null;
        this.searchTermEl = null;
        this.loadingEl = null;
        this.itemsPerPage = 9;
        this.currentPage = 1;
        this.exceptNodeId = 0;
        this.lastPage = false;
        this.loading = false;
        this.getDataFromServer = function () {
            _this.updateUrl();
            var thisEl = _this;
            fetch("/umbraco/surface/newssurface/getnews?".concat(_this.getQueryStrings()))
                .then(function (response) {
                return response.text();
            })
                .then(function (html) {
                if (thisEl.currentPage == 1) {
                    thisEl.newsContainerEl.innerHTML = html;
                }
                else {
                    thisEl.newsContainerEl.innerHTML += html;
                }
                thisEl.newsContainerEl.classList.remove("loading");
                setTimeout(function () { return thisEl.showNewsItems(); }, 300);
                loadParallax();
                thisEl.loading = false;
                if (thisEl.loadingEl)
                    thisEl.loadingEl.style.display = "none";
                thisEl.shouldDisableLoadMore();
            });
        };
        this.searchTimeout = null;
        this.onSearch = function () {
            _this.currentPage = 1;
            _this.lastPage = false;
            _this.getDataFromServer();
        };
        this.newsContainerEl = el;
        this.init();
        this.addListeners();
    }
    NewsSearch.prototype.init = function () {
        var _a, _b, _c, _d, _e, _f;
        this.categoryEl = document.getElementById("category");
        this.searchTermEl = document.getElementById("searchTerm");
        this.loadingEl = document.getElementById("news-loading");
        this.itemsPerPage = parseInt((_b = (_a = this.newsContainerEl.getAttribute("data-itemsperpage")) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "");
        this.currentPage = parseInt((_d = (_c = this.newsContainerEl.getAttribute("data-currentpage")) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "");
        this.exceptNodeId = parseInt((_f = (_e = this.newsContainerEl.getAttribute("data-exceptnodeid")) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : "");
        this.showNewsItems();
        this.shouldDisableLoadMore();
    };
    NewsSearch.prototype.addListeners = function () {
        var _this = this;
        var _a, _b;
        //Bind events
        (_a = this.categoryEl) === null || _a === void 0 ? void 0 : _a.addEventListener("change", function () { return _this.onSearch(); });
        (_b = this.searchTermEl) === null || _b === void 0 ? void 0 : _b.addEventListener("keyup", function () { return _this.onTextSearch(); });
        window.addEventListener("scroll", function () { return _this.onScroll(); });
    };
    NewsSearch.prototype.onScroll = function () {
        if (this.lastPage)
            return;
        if (this.loading)
            return;
        var items = document.querySelectorAll(".list-item");
        var count = items.length;
        var lastItem;
        items.forEach(function (el, i) {
            if (i + 1 == count)
                lastItem = el;
        });
        var top = 0;
        if (lastItem)
            top = lastItem.offsetTop;
        var scrollPos = window.scrollY;
        //document.title = (scrollPos + " - y:" + top);
        if (scrollPos >= top) {
            this.currentPage = this.currentPage + 1;
            this.getDataFromServer();
            this.loading = true;
            if (this.loadingEl)
                this.loadingEl.style.display = "block";
        }
    };
    NewsSearch.prototype.onTextSearch = function () {
        this.newsContainerEl.classList.add("loading");
        if (this.searchTimeout)
            clearTimeout(this.searchTimeout);
        var thisEl = this;
        this.searchTimeout = setTimeout(function () {
            thisEl.onSearch();
        }, 500);
    };
    NewsSearch.prototype.getQueryStrings = function () {
        var _a, _b;
        var querystrings = [];
        var category = (_a = this.categoryEl) === null || _a === void 0 ? void 0 : _a.value;
        var searchTerm = (_b = this.searchTermEl) === null || _b === void 0 ? void 0 : _b.value;
        querystrings.push("category=".concat(category));
        querystrings.push("searchTerm=".concat(searchTerm));
        querystrings.push("page=".concat(this.currentPage));
        querystrings.push("itemsPerPage=".concat(this.itemsPerPage));
        querystrings.push("except=".concat(this.exceptNodeId));
        return querystrings.join("&");
    };
    NewsSearch.prototype.updateUrl = function () {
        var _a, _b;
        var querystrings = [];
        var category = (_a = this.categoryEl) === null || _a === void 0 ? void 0 : _a.value;
        var searchTerm = (_b = this.searchTermEl) === null || _b === void 0 ? void 0 : _b.value;
        querystrings.push("category=".concat(category));
        querystrings.push("searchTerm=".concat(searchTerm));
        querystrings.push("page=".concat(this.currentPage));
        var query = querystrings.join("&");
        window.history.pushState({}, "", "?" + query);
    };
    NewsSearch.prototype.showNewsItems = function () {
        document.querySelectorAll(".list-item")
            .forEach(function (item) {
            item.classList.remove("fade");
        });
    };
    NewsSearch.prototype.shouldDisableLoadMore = function () {
        var lastPageIndicator = document.getElementById("lastpage");
        if (lastPageIndicator) {
            this.lastPage = true;
        }
    };
    return NewsSearch;
}());
export default function initNewsSearch() {
    var newsContainer = document.getElementById("news-container");
    if (newsContainer)
        new NewsSearch(newsContainer);
}
